import classNames from "classnames";
import { MouseEventHandler } from "react";

const IconButton = ({
  children,
  onClick,
  disabled = false,
}: {
  children: string | JSX.Element | JSX.Element[];
  onClick?: MouseEventHandler;
  disabled?: boolean;
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        "grid place-content-center",
        "transition bg-grey-lightest rounded-full p-1",
        "hover:bg-grey-light",
        "text-primary",
        {
          "bg-grey-light text-grey-dark": disabled,
        },
      )}
    >
      {children}
    </button>
  );
};

export default IconButton;
